import { Injectable } from '@angular/core';
import { SagaDatePipe } from '@app/pipes/saga-date/saga-date.pipe';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { TranslateService } from '@ngx-translate/core';
import { ICallcardFormatter } from '../../schema/interfaces/callcard-formatter';
import { CardTitleFormatterService } from '../card-title-formatter/card-title-formatter.service';
import { DefaultCallcardFormatter } from './formatters/default-callcard-formatter';

@Injectable({
  providedIn: 'root'
})
export class CallcardFormatterService {
  private formatter: ICallcardFormatter;

  constructor(private translate: TranslateService, private sagaDate: SagaDatePipe, private cardTitleFormatter: CardTitleFormatterService) {}

  format(card: CallCard) {
    this.getInfoFormatter().format(card);
    card.title = this.cardTitleFormatter.format(card);
  }

  private getInfoFormatter(): ICallcardFormatter {
    if (!this.formatter) {
      this.formatter = new DefaultCallcardFormatter(this.translate, this.sagaDate);
    }

    return this.formatter;
  }

  setFormatter(formatter: ICallcardFormatter) {
    this.formatter = formatter;
  }
}
